import { render, staticRenderFns } from "./LotVue.vue?vue&type=template&id=4573b0c6&"
import script from "./LotVue.vue?vue&type=script&lang=js&"
export * from "./LotVue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports